import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  Input,
} from 'semantic-ui-react';

import Validate from './Validate';

class PhoneInput extends Component {
  static propTypes = {
    autoComplete: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.node,
    iconPosition: PropTypes.string,
    label: PropTypes.string,
    loading: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    pattern: PropTypes.string,
    placeholder: PropTypes.string,
    prefix: PropTypes.string,
    readOnly: PropTypes.bool,
    type: PropTypes.string,
    validation: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
          validate: PropTypes.func,
          option: PropTypes.object,
        }),
      ]).isRequired,
    ),
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    validateLabel: PropTypes.string,
    validateRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({}),
    ]),
  }
  getClassName = () => {
    const { className, prefix } = this.props;
    if (className && className !== '') return className;
    if (prefix && prefix !== '') return prefix;
    return null;
  }
  render() {
    return (
      <div className="field">
        {
          this.props.label !== '' ?
            <label htmlFor={this.props.name} style={this.props.disabled ? { opacity: 0.22 } : {}}>{this.props.label}</label>
          : null
        }
        <Validate
          validation={this.props.validation}
          label={this.props.validateLabel || this.props.label}
          name={this.props.name}
          ref={this.props.validateRef}
          onChange={(e, data) => {
            // bubble up onChange
            if (this.props.onChange) {
              this.props.onChange(e, data);
            }
          }}
        >
          <Input
            className={this.getClassName()}
            autoComplete={this.props.autoComplete}
            disabled={this.props.disabled}
            fluid
            icon={this.props.icon ? this.props.icon : null}
            iconPosition={this.props.iconPosition && this.props.iconPosition !== '' ? this.props.iconPosition : null}
            label={this.props.prefix && this.props.prefix !== '' ? this.props.prefix : null}
            loading={this.props.loading}
            name={this.props.name}
            pattern={this.props.pattern}
            placeholder={this.props.placeholder}
            readOnly={this.props.readOnly}
            type={this.props.type}
            value={this.props.value}
          />
        </Validate>
      </div>
    );
  }
}

export default forwardRef((props, ref) => <PhoneInput {...props} validateRef={ref} />);



// WEBPACK FOOTER //
// ./src/components/AppForm/PhoneInput.jsx